


import { useState } from "react";
import styles from "../HealthChat.module.css";
import { EnglishIcon, HindiIcon, TeluguIcon } from "../langIcons";
import translations from "../translations.json";
import { BotIcon, SosIcon, CloseIcon } from "../icons";

const LANGUAGES = [
  { code: "en", nativeLabel: "English", Icon: EnglishIcon },
  { code: "hi", nativeLabel: "हिंदी", Icon: HindiIcon },
  { code: "te", nativeLabel: "తెలుగు", Icon: TeluguIcon },
];

export default function WelcomeScreen({ onStart, onClose }) {
  const [selectedLang, setSelectedLang] = useState("en");
  const t = translations["en"].language;

  return (
    <div className={styles.welcomeScreen}>
      < button   className={styles.welcomeCloseBtn} onClick={onClose}><CloseIcon/></button>
      {/* Bot avatar */}
      <div className={styles.welcomeContent}>
        <div className={styles.welcomeBotWrap}>
          <img
            src="/images/chatbotFemCare.svg"
            alt="Avexa AI Chatbot"
            width={100}
            height={100}
            className={styles.welcomeBotImg}
          />
        </div>

        <h1 className={`ava-heading-lg ${styles.welcomeTitle}`}>Welcome!</h1>
        <h2 className={`ava-text-body ${styles.welcomeSubtitle}`}>
          We're here to assist you with your health concernst.
        </h2>

        {/* Language label */}
        <div className={`ava-text-body ${styles.welcomeLangLabel}`}>{t.title}</div>

        {/* Language buttons row */}
        <div className={styles.welcomeLangRow}>
          {LANGUAGES.map(({ code, nativeLabel, Icon }) => (
            <button
              key={code}
              className={
                selectedLang === code
                  ? styles.welcomeLangBtnActive
                  : styles.welcomeLangBtn
              }
              onClick={() => setSelectedLang(code)}
            >
              <span className={styles.welcomeLangIcon}>
                <Icon size={22} />
              </span>
              <span className={` ${styles.welcomeLangText}`}>{nativeLabel}</span>
            </button>
          ))}
        </div>

        {/* Get Started */}
        <button
          className={styles.welcomeBtn}
          onClick={() => onStart(selectedLang)}
        >
          Get Started
        </button>
      </div>

      <div className={`ava-text-caption ${styles.welcomeFooterHint}`}>
        I'm here to help – feel free to ask anything.
      </div>
    </div>
  );
}

